import {
  PAYMENT_METHODS_ENUM,
  PAYMENT_STEPS,
} from "../../types/PaymentMethodsTypes";
import { setStep } from "../../redux/payment/slice";
import { PAYMENT_METHOD_ACTIONS, setPaymentPage, redirectToUrl } from ".";

export const handlerPaymentMethodAction = (
  method,
  data,
  dispatch,
  submethod?: string,
) => {
  const action = PAYMENT_METHOD_ACTIONS[method];
  if (action) {
    if (method === PAYMENT_METHODS_ENUM.COREFY && submethod) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      handleCorefySpecific(submethod, data, dispatch);
    } else {
      action(data, dispatch);
    }
  }
};

const handleCorefySpecific = (submethod, data, dispatch) => {
  switch (submethod) {
    case "GBP":
    case "EUR":
      redirectToUrl("redirectUrl", data, dispatch);
      break;
    case "KZT":
      setPaymentPage("pluginUrl", data, dispatch);
      break;
    case "TRY":
      setPaymentPage("pluginUrl", data, dispatch);
      break;
    case "AZN":
      redirectToUrl("pluginUrl", data, dispatch);
      break;
    default:
      dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};
